import CivilJudgement from './CivilJudgement';

export default CivilJudgement;
